export default "__VITE_ASSET__CGUMtluW__"